import styles from './FlatCard.module.scss';

import isEmpty from 'lodash/isEmpty';
import React, { FC, HTMLAttributes } from 'react';

import type { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { ContentImage } from 'components/ContentImage/ContentImage';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { Grid } from 'components/Grid/Grid';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';
import { TextV2 } from 'components/TextV2/TextV2';
import type { FlatEntry } from 'services/cms/flattenContentful';

interface IFlatCardProps extends HTMLAttributes<HTMLElement> {
  item?: FlatEntry<Subject>;
}

export const FlatCard: FC<IFlatCardProps> = ({ item }) => {
  if (isEmpty(item)) return null;
  const { title: buttonTitle, blurb, image, link, richBlurb } = item;

  return (
    <Grid item key={buttonTitle} md={6} lg={6} className={styles.solutionPickerModuleItemsListGridStyle}>
      <ContentLinkV2 entry={link} hideTitle className={styles.solutionPickerModuleCard}>
        <ContentImage entry={image} className={styles.solutionPickerModuleCardImage} />
        <TextV2
          value={buttonTitle}
          entry={{ ...item, field: 'title' }}
          tagName="h5"
          variant="h5-medium"
          className={styles.solutionPickerModuleCardText}
        />
        <TextV2
          value={blurb}
          entry={{ ...item, field: 'blurb' }}
          tagName="p"
          variant="body"
          className={styles.solutionPickerModuleCardBlurb}
        />
        <RichBlurb document={richBlurb} className={styles.solutionPickerModuleCardBlurb} />
      </ContentLinkV2>
    </Grid>
  );
};
